import { useAuth0 } from '@auth0/auth0-react';
import { Box, Button, Typography } from '@mui/material';
import { useEffect } from 'react';

interface AccessDeniedProps {
  autoLogout?: boolean;
  logoutDelay?: number;
}

export default function AccessDenied({ autoLogout = false, logoutDelay = 5000 }: AccessDeniedProps): JSX.Element {
  const { logout } = useAuth0();

  useEffect(() => {
    if (!autoLogout) {
      return;
    }

    const timer = setTimeout(() => {
      void logout({
        logoutParams: {
          returnTo: import.meta.env.VITE_APP_OYSTEHR_APPLICATION_REDIRECT_URL,
          federated: true,
        },
      });
    }, logoutDelay);

    return () => clearTimeout(timer);
  }, [autoLogout, logoutDelay, logout]);

  const handleLogout = (): void => {
    void logout({
      logoutParams: {
        returnTo: import.meta.env.VITE_APP_OYSTEHR_APPLICATION_REDIRECT_URL,
        federated: true,
      },
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 3,
        px: 3,
      }}
    >
      <Typography variant="h4" color="error" textAlign="center">
        Acceso Denegado
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center" maxWidth="600px">
        No tienes permisos para acceder a este portal. Este portal es exclusivo para profesionales de la salud.
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        Si crees que esto es un error, por favor contacta al administrador del sistema.
      </Typography>
      {autoLogout ? (
        <Typography variant="body2" color="text.secondary">
          Cerrando sesión automáticamente en {logoutDelay / 1000} segundos...
        </Typography>
      ) : (
        <Button variant="contained" color="primary" onClick={handleLogout}>
          Cerrar Sesión
        </Button>
      )}
    </Box>
  );
}
